import GeoJSON from "ol/format/GeoJSON.js";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer.js";
import { bbox as bboxStrategy } from "ol/loadingstrategy.js";
import { Icon, Fill, Stroke, Style, Text } from "ol/style.js";
import VectorSource from "ol/source/Vector.js";
import { register as projRegister } from "ol/proj/proj4.js";
import { get as getProjection } from "ol/proj.js";
import TileWMS from "ol/source/TileWMS.js";
import proj4 from "proj4/dist/proj4.js";
import WMTS from "ol/source/WMTS.js";
import WMTSTileGrid from "ol/tilegrid/WMTS.js";
import TileGrid from "ol/tilegrid/TileGrid.js";
import Point from "ol/geom/Point.js";
import Feature from "ol/Feature.js";
import axios from "axios";
//import EPSG4326 from "../config/EPSG4326.json";
import EPSG4326 from "../config/ESPG32721.json";
import markerIco from "../images/marker.svg";

proj4.defs(
  "EPSG:32721",
  "+proj=utm +zone=21 +south +datum=WGS84 +units=m +no_defs"
);

projRegister(proj4);

const style = new Style({
  
  stroke: new Stroke({
    color: "rgba(255,0,0,0.8)",
    width: 1
  }),
  fill: new Fill({
    color: "rgba(255,0,0,0.4)"
  })
});

const extent = EPSG4326.extent;
const proj = EPSG4326.name;
const center = EPSG4326.center;
const BASE_URI ="/geoserver";
/**
 * Se encarga de manejar la sesión del usuario.
 */
class GeoHelper {
  srs = proj;
  projection = getProjection(proj);
  center = center;
  extent = extent;
  tileGrid = new TileGrid(EPSG4326);

  /**
   * Se encarga de realizar un request WFS para recuperar la información en formato
   * vectorial.
   *
   * @param {*} params
   * @param{string}params.title
   * @param{string}params.featureNS
   * @param{string}params.featurePrefix
   * @param{string}params.featureTypes
   * @param{string}params.filter
   *
   */
  wfs(params) {
    let urlParams = {
      service: "WFS",
      version: "1.1.0",
      request: "GetFeature",
      outputFormat: "application/json",
      srsname: this.srs,
      typename: params.workspace + ":" + params.layer,
      CQL_FILTER: params.filter
    };
    let query = "?";
    for (let attr in urlParams) {
      query += attr + "=" + urlParams[attr] + "&";
    }

    var vectorSource = new VectorSource({
      format: new GeoJSON(),
      url: `${BASE_URI}/ows${query}`,
      strategy: bboxStrategy
    });

    return new VectorLayer({
      title: params.title,
      visible: params.visible,
      style: style,
      source: vectorSource
    });
  }

  /**
   * Se encarga de realizar el request a GWC para recumerar la informacion con
   * el protocolo wms.
   *
   * @param{string}params.title
   * @param{string}params.layers
   */
  wms(params) {
    return new TileLayer({
      title: params.title,
      visible: params.visible,
      source: new TileWMS({
        //url: "/geoserver2/wms",
        url: `${BASE_URI}/gwc/service/wms`,
        params: {
          VERSION: "1.1.1",
          LAYERS: params.layers,
          TILED: true,
          FORMAT: "image/png",
          SRS: proj,
          TRANSPARENT: true
        },
        serverType: "geoserver",
        tileGrid: this.tileGrid
      })
    });
  }

  /**
   * Se encarga de realizar el request a GWC para recumerar la informacion con
   * el protocolo wtms.
   *
   * @param {*} params
   */
  wmts(params) {
    return new TileLayer({
      title: params.title,
      visible: params.visible,
      source: new WMTS({
        url: `${BASE_URI}/gwc/service/wmts`,
        SERVICE: "WMTS",
        VERSION: "1.0.0",
        layer: params.layers,
        matrixSet: proj,
        format: "image/png",
        projection: getProjection(proj),
        tileGrid: new WMTSTileGrid(EPSG4326),
        wrapX: true,
        serverType: "geoserver",
        crossOrigin: "anonymous"
      })
    });
  }
  /**
   * Se encarga de realizar el request para recuperar la información del feature
   * donde se hace click.
   * @param {*} map
   * @param {*} layer
   * @param {*} coordinate
   */
  getFeatureInfo(map, layer, coordinate) {
    var view = map.getView();
    var viewResolution = view.getResolution();
    var source = layer.getSource();
    var url = source.getGetFeatureInfoUrl(
      coordinate,
      viewResolution,
      view.getProjection(),
      { INFO_FORMAT: "application/json", FEATURE_COUNT: 5 }
    );
    return axios.get(url);
  }

  /**
   * Se encarga de construir un layer del tipo point para renderizar un
   * marker.
   *
   * @param {*} data
   *
   */
  marker(data) {
    var iconFeature = new Feature({
      //geometry: new Point([data.lon, data.lat])
      geometry: new Point(data),
      name: "Marker",
      population: 4000,
      rainfall: 500
    });

    var iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "pixels",
        src: markerIco
      })
    });

    iconFeature.setStyle(iconStyle);

    var vectorSource = new VectorSource({
      features: [iconFeature]
    });

    return new VectorLayer({
      title: "Marker",
      source: vectorSource,
      visible: true
    });
  }
}
export default new GeoHelper();
